export class ListResult<T> {

  public items: T[];
  public index: number;
  public total: number;

  constructor(items: T[], index?: number, total?: number) {
    this.items = items;
    this.index = index || 0;
    this.total = total || (items ? items.length : 0);
  }

  static empty<T>(): ListResult<T> {
    return new ListResult<T>([], 0, 0);
  }

}


/**
 * Returns a new list result where all the items have been mapped to a different type.
 */
export function mapListResult<A, B>(original: ListResult<A>, mapItem: (a: A) => B): ListResult<B> {
  return new ListResult(
    original.items.map(mapItem),
    original.index,
    original.total,
  );
}
